import React from "react";
import { ExpertsApplyModel } from "../../../../domain/ExpertsApplyFormModel";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, makeStyles } from "@material-ui/core";
import { useDispatch, } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { Error } from "../../../common/Error";
import { MarkdownEditor } from "@ofqual/portal-components/components/MarkdownEditor";
import { FileInput } from "@ofqual/portal-components/components/FileInput";
import { addCaseNote } from "../../../../redux/actions";
import { TextField } from "@ofqual/portal-components/components/TextField";

const useStyles = makeStyles((_) => ({
  actions: {
    padding: 15,
  },
}));


export const AddNoteDialog: React.FC<{
  onClose: () => void;
  resource: ExpertsApplyModel;
}> = ({ onClose, resource }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { handleSubmit, control, errors } = useForm({
    defaultValues: {
      message: null,
      messageFiles: [],
      caseNote: null,
      subject: null
    },
  });

  const handleAddNote = (data: {
    caseFiles: File[];
    caseNote: string;
    sla_ResponseType: number;
    subject: string;
  }) => {
    dispatch(
      addCaseNote(
        resource.id,
        data.caseFiles,
        data.caseNote,
        data.subject
      )
    );
    onClose();
  };

  return (
    <Dialog open={true} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle data-test="activity-title">Add a note</DialogTitle>
      <Divider />
      <DialogContent style={{ minHeight: "250px" }}>
        <form>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Controller
                control={control}
                name="subject"
                rules={{ required: true }}
                render={({ onChange, value }) => (
                  <TextField
                    onChange={onChange}
                    value={value}
                    data-test="case-note-subject-field"
                    label="Subject"
                    required
                  />
                )}
                required
              />
              {errors.subject && (
                <Error data-test="case-note-subject-field-error">
                  This field is required
                </Error>
              )}
            </Grid>
            <Grid item xs={12}>
              <Controller
                control={control}
                name="caseNote"
                rules={{ required: true }}
                render={({ onChange, value }) => (
                  <MarkdownEditor
                    onChange={onChange}
                    value={value}
                    dataTest="create-note-text-field"
                  />
                )}
              />
              {errors.caseNote && (
                <Error data-test="create-note-text-field-error">
                  This field is required
                </Error>
              )}
            </Grid>
            <Grid item xs={12}>
              <Controller
                control={control}
                name="caseFiles"
                as={
                  <FileInput
                    multiple={true}
                    dataTest="create-note-add-attachment-button"
                  />
                }
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button
          onClick={onClose}
          color="primary"
          data-test="close-add-note-dialog"
        >
          Close
        </Button>
        <Button
          onClick={handleSubmit(handleAddNote)}
          color="primary"
          data-test="add-note-message-button"
        >
          Add
        </Button>
      </DialogActions>
      <Divider />
    </Dialog>
  );
};
